import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pullAhead',
})
export class PullAheadPipe implements PipeTransform {
  transform<T>(value: T[], selector: (item: T, index?: number, arr?: T[]) => boolean): T[] {
    const collectionCopy = Array.from(value);
    const itemIndex = collectionCopy.findIndex(selector);
    const item = collectionCopy.splice(itemIndex, 1);
    collectionCopy.splice(0, 0, ...item);
    return collectionCopy;
  }
}
